import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import Icon from 'app/common/Icon/index';
import classes from './style.module.scss';
import { ServiceCheckPayload } from "types/index";
import { useStoreState } from "~/store";
import List from "~/issues/List/List";
import useTranslation from '~/app/hooks/useTranslation';
import { ServiceStatuses } from '~/app/data/statuses/services';
import useAccessControl from '~/app/hooks/useAccessControl';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';

export interface ListItemProps {
    item: ServiceCheckPayload
    onSelect?: (item: any, status: ServiceCheckPayload['status']) => void
}

export type ListItemComponent = React.FC<ListItemProps>

const ListItem: ListItemComponent = ({ item, onSelect }) => {

    const { t } = useTranslation('serviceChecklist');
    const [...allIssues] = useStoreState(state => state.machine.data.issues);

    const { checkPermission } = useAccessControl();
    const writeServiceDetailsPermission = checkPermission(PERMISSION_GROUPS.writeServiceDetails);

    const isServiceChecklistEnabled = useStoreState((state) => {
        const hasSimplifiedWorkorder = state.service.hasSimplifiedWorkorder ?? false;
        const status =  state.service.data.status;
        const workOrderNo =  state.service.data.workOrderNo;
        return hasSimplifiedWorkorder && ((status === ServiceStatuses.TRIGGERED) || (status === ServiceStatuses.INPROGRESS && workOrderNo));
    });

    const statusChangeHandler = useCallback((newStatus) => {
        if (isServiceChecklistEnabled && writeServiceDetailsPermission && onSelect) {
            onSelect(item, (newStatus === item.status) ? null : newStatus);
        }
    }, [isServiceChecklistEnabled, writeServiceDetailsPermission, onSelect, item]);

    const registerIssue = useCallback(() => {
        if (onSelect) {
            onSelect(item, 0);
        }
    }, [item, onSelect]);

    const serviceCheckIssues = useMemo(() => {        
        return allIssues.reverse().filter(issue => item.issues.toString() === (issue.id.toString()));
    }, [item.issues, allIssues]);

    return (
        <>
            <div className={classes['list-item-wrapper']}>
                <div className={`${classes['list-item']} ${serviceCheckIssues.length ? classes['show-issues'] : ''}`}>
                    <div className={`${classes['title']} ${item.sectionId && !item.isServiceSection ? classes['add-tab'] : ''}`}>{item.sequenceNumber} {item.name}</div>
                    {item.isServiceSection === false && (
                        <div className={classNames(classes['icon-wrap'])}>
                            <Icon name={'close'}
                                className={`${classes['cancel']} ${item.status === 0 ? classes['checked'] : ''} ${item.status === 1 ? classes['disabled'] : ''}`}
                                onClick={() => statusChangeHandler(0)}
                            />
                            <Icon name={'done'}
                                className={`${classes['ok']} ${item.status === 1 ? classes['checked'] : ''} ${item.status === 0 ? classes['disabled'] : ''}`}
                                onClick={() => statusChangeHandler(1)}
                            />
                        </div>
                    )}
                </div>
            </div>
            {serviceCheckIssues.length > 0 && (
                <>
                    <List list={serviceCheckIssues} listClassName={'periodic-check-issues'} />
                    {isServiceChecklistEnabled && item.status !== 1 && <div className={classes['register-issue-link']} onClick={registerIssue}>{t('registerNewIssue')}</div>}
                </>
            )}
        </>
    );
};

export default ListItem
